export enum ConsultNoteQueueFilterName {
  clientIds = 'client_ids[]',
  clientStates = 'client_states[]',
  statuses = 'statuses[]',
  specialtyStore = 'specialty_store',
  expiringWithinDays = 'expiring_within_days',
  outboundFaxNumber = 'outbound_fax_number',
  highValue = 'high_value',
  assignedClientLeadsIds = 'assigned_client_leads_ids[]',
  assignedToIds = 'assigned_to_ids[]',
  excludeDirectUserAssignmentWorkflowClients = 'exclude_direct_user_assignment_workflow_clients',
}
